import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

export default function Footer() {
  const { t } = useTranslation();
  const { lang = 'en' } = useParams<{ lang: string }>();

  const resourceLinks = [
    { label: 'Spreadsheet', href: 'https://kaspreadsheet.com' },
    { label: 'Guides', href: 'https://kaspreadsheet.com' },
    { label: 'Reviews', href: 'https://kaspreadsheet.com' },
    { label: 'Shipping', href: 'https://kaspreadsheet.com' },
    { label: 'QC', href: 'https://kaspreadsheet.com' },
    { label: 'Sellers', href: 'https://kaspreadsheet.com' },
  ];

  const guideLinks = [
    { label: 'Complete Guide', href: `/${lang}/article/allchinabuy-spreadsheet-complete-guide` },
    { label: 'Beginner Guide', href: `/${lang}/article/allchinabuy-beginner-guide` },
    { label: 'Shipping Guide', href: `/${lang}/article/allchinabuy-shipping-guide` },
    { label: 'QC Guide', href: `/${lang}/article/allchinabuy-qc-guide` },
    { label: 'Safety Guide', href: `/${lang}/article/allchinabuy-safety-guide` },
    { label: 'Review 2026', href: `/${lang}/article/allchinabuy-review` },
  ];

  return (
    <footer className="w-full bg-white border-t border-gray-100">
      <div className="w-full px-4 sm:px-6 lg:px-10 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 mb-10">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2 text-lg font-bold mb-4">
              <span className="text-emerald-700">AllChinaBuy</span>
              <span className="text-gray-700">Spreadsheet</span>
            </div>
            <p className="text-sm text-gray-500 leading-relaxed">
              An independent informational resource for smarter product research and buying decisions.
            </p>
          </div>

          {/* Resources */}
          <div>
            <h3 className="text-sm font-semibold text-gray-900 mb-4">{t('footer_resources')}</h3>
            <ul className="space-y-2.5">
              {resourceLinks.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-gray-500 hover:text-emerald-600 transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Guides */}
          <div>
            <h3 className="text-sm font-semibold text-gray-900 mb-4">Popular Guides</h3>
            <ul className="space-y-2.5">
              {guideLinks.map((link) => (
                <li key={link.label}>
                  <a href={link.href} className="text-sm text-gray-500 hover:text-emerald-600 transition-colors">
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Disclaimer */}
        <div className="border-t border-gray-100 pt-6">
          <p className="text-xs text-gray-400 text-center leading-relaxed max-w-3xl mx-auto">
            {t('footer_disclaimer')}
          </p>
          <p className="text-xs text-gray-400 text-center mt-3">
            &copy; {new Date().getFullYear()} AllChinaBuy Spreadsheet. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}